const o = {
  update: i,
  inserted: i
};
function i(e, t) {
  var a;
  if (!window.ws_analytics)
    return console.log("ws-analytics is not initialized");
  (a = window.ws_analytics.stored) != null && a[t.value] && (Object.keys(window.ws_analytics.stored[t.value]).forEach((s) => {
    e.addEventListener(s, window.ws_analytics.stored[t.value][s]), e.setAttribute("data-tracking", t.value);
  }), delete window.ws_analytics.stored[t.value]);
}
export {
  o as WsAnalyticsDirective
};
//# sourceMappingURL=index.es.js.map
